export enum MapMode {
  CLASSIC = 'CLASSIC',
  DARK = 'DARK'
}
